/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useHandleShowDialogs } from 'forms/hooks';
import { includes } from 'ramda';
import { isObject } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import useFormData from '@gef-ui/form-core/hooks/state/useFormData';
import { validationDisplayTypes } from '@gef-ui/form-material/constants';
import SubmitButton from '@gef-ui/form-material/SubmitButton';
import { getLabelMessage } from '@gef-ui/localization/messages';

import Agency from 'components/atoms/GefMui/OrganizationStructure/Agency';
import Manager from 'components/atoms/GefMui/OrganizationStructure/Manager';
import Region from 'components/atoms/GefMui/OrganizationStructure/Region';
import { AUTO_FILL_RULES } from 'constants/general';
import dialog from 'features/common/dialog';
import { resetErrorsByPage } from 'features/common/submitFormDialog/slice';
import {
	initializeOrganizationStructure,
	resetSubsellerNominations,
	submitFilter,
} from 'features/views/campaignSubsellerNomination/actions';
import { CAMPAIGN_SUBSELLER_NOMINATIONS_FORM_NAME, FIELDS } from 'features/views/campaignSubsellerNomination/form';
import user from 'features/views/user';

const Form = () => {
	const dispatch = useDispatch();
	const currentRole = useSelector(user.selectors.getCurrentRole);
	const formData = useFormData();
	const formIsInitiated = isObject(formData);

	useEffect(() => {
		if (formIsInitiated) {
			dispatch(initializeOrganizationStructure());
		}
	}, [formIsInitiated]);

	const handleReset = useCallback(() => {
		dispatch(resetSubsellerNominations());
	}, [dispatch]);

	const handleSubmit = useCallback(() => {
		// close and reset all the "required" errors
		dispatch(dialog.actions.close(CAMPAIGN_SUBSELLER_NOMINATIONS_FORM_NAME));
		dispatch(resetErrorsByPage({ page: CAMPAIGN_SUBSELLER_NOMINATIONS_FORM_NAME }));
		dispatch(submitFilter(formData));
	}, [dispatch, formData]);

	const handleShowDialogsForSubmit = useHandleShowDialogs({
		page: CAMPAIGN_SUBSELLER_NOMINATIONS_FORM_NAME,
		continueFn: handleSubmit,
	});

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container spacing={2}>
					<Grid size={4}>
						<Region
							fieldName={FIELDS.region}
							formName={CAMPAIGN_SUBSELLER_NOMINATIONS_FORM_NAME}
							disableOnOneOptions={!includes(currentRole, AUTO_FILL_RULES.CENTRAL)}
							autoSelect
							validationDisplay={validationDisplayTypes.HIDDEN}
						/>
					</Grid>
					<Grid size={4}>
						<Agency
							fieldName={FIELDS.agency}
							formName={CAMPAIGN_SUBSELLER_NOMINATIONS_FORM_NAME}
							disableOnOneOptions={!includes(currentRole, AUTO_FILL_RULES.REGION_MANAGER)}
							autoSelect
							validationDisplay={validationDisplayTypes.HIDDEN}
						/>
					</Grid>
					<Grid size={4}>
						<Manager
							fieldName={FIELDS.manager}
							formName={CAMPAIGN_SUBSELLER_NOMINATIONS_FORM_NAME}
							disableOnOneOptions={!includes(currentRole, AUTO_FILL_RULES.AGENCY_MANAGER)}
							autoSelect
						/>
					</Grid>
					<Grid size={8} />
					<Grid size={2}>
						<Button variant="outlined" onClick={handleReset} fullWidth>
							{getLabelMessage('common:resetButton')}
						</Button>
					</Grid>
					<Grid size={2}>
						<SubmitButton
							variant="contained"
							onClick={handleSubmit}
							onClickError={handleShowDialogsForSubmit}
							fullWidth
							text={getLabelMessage('common:searchButton')}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Form;
